import Vue from 'vue';
import I18n from 'vue-i18n';

import messages from '@/translations';

Vue.use(I18n);

const i18n = new I18n({
  locale: 'vi',
  messages
});

export default i18n;
